import { useCallback, useEffect, useState } from 'react';
import { getVeiculosPropriosPremiacao } from '@spark/services/premiacao';
import { notification } from '@spark/ui-components/utils/notification';

const pick = (data, ...keys) => {
  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index];
    if (data?.[key] !== undefined && data?.[key] !== null) {
      return data[key];
    }
  }
  return undefined;
};

const toRowModel = (item) => ({
  id: pick(item, 'numeroFrota', 'NumeroFrota') || '',
  numeroFrota: pick(item, 'numeroFrota', 'NumeroFrota') || '',
  placa: pick(item, 'placa', 'Placa') || '',
  segmento: pick(item, 'segmento', 'Segmento') || '',
  modelo: pick(item, 'modelo', 'Modelo') || '',
  motorista: pick(item, 'motorista', 'Motorista') || '',
  nomesTabelasPremiacao: pick(item, 'nomesTabelasPremiacao', 'NomesTabelasPremiacao') || '',
  gestor: pick(item, 'gestor', 'Gestor') || '',
  jaVinculadaTabelaAtual: pick(item, 'jaVinculadaTabelaAtual', 'JaVinculadaTabelaAtual') === true
});

export const usePremiacaoVeiculoProprioSelection = (show, idTabelaPremiacao) => {
  const [veiculos, setVeiculos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(25);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [filtros, setFiltros] = useState({});

  const carregarVeiculos = useCallback(async () => {
    if (!show) {
      return;
    }

    try {
      setLoading(true);
      const response = await getVeiculosPropriosPremiacao({
        PaginaAtual: paginaAtual,
        QuantidadePorPagina: quantidadePorPagina,
        IdTabelaPremiacao: idTabelaPremiacao || undefined,
        ...filtros
      });
      const data = response?.data || response || {};
      const lista = Array.isArray(data.registros) ? data.registros : [];

      setVeiculos(lista.map(toRowModel));
      setTotalRegistros(data.totalRegistros || lista.length);
    } catch (error) {
      console.error('Erro ao carregar veiculos proprios:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar os veiculos proprios',
        'Erro ao carregar veiculos'
      );
      setVeiculos([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [show, paginaAtual, quantidadePorPagina, idTabelaPremiacao, filtros]);

  useEffect(() => {
    if (!show) {
      setVeiculos([]);
      setTotalRegistros(0);
      setPaginaAtual(1);
      setFiltros({});
      return;
    }
    carregarVeiculos();
  }, [show, carregarVeiculos]);

  useEffect(() => {
    setPaginaAtual(1);
  }, [idTabelaPremiacao, filtros]);

  const handleFiltrosChange = useCallback((novosFiltros) => {
    setFiltros(novosFiltros || {});
  }, []);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  const reload = useCallback(() => {
    carregarVeiculos();
  }, [carregarVeiculos]);

  return {
    veiculos,
    loading,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
    reload
  };
};
